import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["disabled", "readOnly", "mouseflowExclude", "onChange", "Input", "style", "width"],
    _excluded2 = ["lineHeight"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { prefixStyle } from '@lada/prefix';
import TextInput from '@bubble-ui/primitive-text-input';
// @ts-expect-error
import MouseflowExclude from '@bubble-contrib/support-mouseflow-exclude';

var InputParticle = function InputParticle(_ref) {
  var disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      mouseflowExclude = _ref.mouseflowExclude,
      _onChange = _ref.onChange,
      Input = _ref.Input,
      style = _ref.style,
      width = _ref.width,
      props = _objectWithoutProperties(_ref, _excluded);

  var lineHeight = style.lineHeight,
      restOfStyle = _objectWithoutProperties(style, _excluded2);

  var inputElement = Input ? /*#__PURE__*/React.createElement(Input, _extends({
    onChange: function onChange(e) {
      return (!disabled || !readOnly) && (_onChange === null || _onChange === void 0 ? void 0 : _onChange(e.target.value, e));
    },
    disabled: disabled,
    readOnly: readOnly
  }, props, {
    // @ts-expect-error
    style: prefixStyle(_objectSpread(_objectSpread(_objectSpread({
      backgroundColor: 'transparent',
      border: 'none',
      boxSizing: 'border-box',
      outline: 'none'
    }, restOfStyle), {}, {
      fontSmoothing: 'antialiased',
      textRendering: 'geometricPrecision'
    }, lineHeight && {
      lineHeight: "".concat(lineHeight, "px")
    }), {}, {
      width: width != null ? width : '100%'
    }))
  })) : /*#__PURE__*/React.createElement(TextInput, _extends({
    disabled: disabled,
    readOnly: readOnly,
    onChange: _onChange,
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: width != null ? width : '100%'
    })
  }, props));
  return mouseflowExclude ? /*#__PURE__*/React.createElement(MouseflowExclude, null, inputElement) : inputElement;
};

export default InputParticle;
//# sourceMappingURL=index.js.map